import { Center, Loader } from "@mantine/core";

import { CreateOrEditGate } from "~/features/gates/CreateOrEditGate";
import { useGateQuery } from "~/features/gates/queries/gates.graphql.generated";

const GateEditModal = ({
  gateId,
  onSave,
}: {
  gateId: string;
  onSave: (gateName: string) => void;
}) => {
  const { data, loading } = useGateQuery({
    variables: {
      id: gateId ?? "",
    },
    fetchPolicy: "network-only",
  });

  if (loading || !data) {
    return (
      <Center h={520}>
        <Loader />
      </Center>
    );
  }

  return <CreateOrEditGate gate={data.gate} onSave={onSave} isModal />;
};

export default GateEditModal;
